const ADD_PRODUCT_TO_CART = 'ADD_PRODUCT_TO_CART';
const REMOVE_PRODUCT_FROM_CART = 'REMOVE_PRODUCT_FROM_CART';
const TRIGGER_CART_LOADING = 'TRIGGER_CART_LOADING';
const TRIGGER_MINICART_ANIMATION = 'TRIGGER_MINICART_ANIMATION';

export {
    ADD_PRODUCT_TO_CART,
    REMOVE_PRODUCT_FROM_CART,
    TRIGGER_CART_LOADING,
    TRIGGER_MINICART_ANIMATION
};



// WEBPACK FOOTER //
// ./src/components/ProductItem/actions/types.js